const EmailProviders = {
    SMTP: 0,
    SendGrid: 1,
    Office365: 2
};
export default EmailProviders;